import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const Card = ({ title, count, icon }) => {
  const { t } = useTranslation("prtFinance");
  return (
    <div
      className="p-5 w-full h-full rounded-2xl border border-purple-400 hover:scale-[101%] transition-transform duration-300 flex gap-4 shadow-md"
    >

      <div className="size-16 flex items-center justify-center rounded-2xl bg-gradient-to-r from-pink-600 to-violet-600 text-white text-3xl shadow-md">
        {icon}
      </div>
      <div className="flex flex-col">
        <h3 className="text-sm font-medium text-gray-600 truncate">{title}</h3>

        <h2 className="text-2xl font-bold text-purple-800 truncate">
          {count}{" "}
          <span className="text-xs">
            {count === 1 ? t("quotation") : t("quotations")}
          </span>
        </h2>
      </div>
    </div>
  );
};

Card.propTypes = {
  title: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  icon: PropTypes.node.isRequired,
  trend: PropTypes.oneOf(["up", "down"]).isRequired,
};

export default Card;
